import { Component, OnDestroy, OnInit } from '@angular/core';
import { FeaturesBaseComponent } from 'src/app/features-common/components/features-base.component';
import { HttpParams } from '@angular/common/http';
import { Params, Router } from '@angular/router';
import { CurrencyPipe, formatDate } from '@angular/common'; 
import * as moment from 'moment';
import { ProvidersService } from '../../../providers.service';
@Component({
  selector: 'app-consumer-all-pricelist',
  templateUrl: './consumer-all-pricelist.component.html',
  styleUrls: ['./consumer-all-pricelist.component.scss'],
  providers: [CurrencyPipe]
})
export class ConsumerAllPricelistComponent extends FeaturesBaseComponent implements OnInit, OnDestroy {
  columnDefs
  rowData: any = [];
  rowSelection: string;
  private gridApi;
  private gridColumnApi;
  showEditRetailer: boolean = false;
  selectedRows: any;
  searchValue: any;
  Pricelists: Array<any>;
  PricelistSelected;
  isPricelistSelected: boolean = false;


  constructor(private router: Router, private providersService: ProvidersService,private currencyPipe: CurrencyPipe) {
    super();
    let httpParams: Params = { input: 'null' }
    //let pricelisttype : 'ho'
    this.providersService.getconsumerpricelists().subscribe(res => { 
      let resData: any = res;
      if (resData.httpcode == 200) {
        resData = resData.data;
        //;
        this.Pricelists = resData;
      }
    })
  }

  ngOnInit(): void {
    super.ngOnInit()


    this.rowSelection = 'single';
    this.columnDefs = [
      { field: 'null', headerName: 'Action', width: 130, checkboxSelection: true },
      { field: 'sku', headerName: 'SKU', width: 120 },
      { field: 'productName', headerName: 'Product Name', width: 180 },
      { field: 'productDescription', headerName: 'Product Description', width: 230 },
      { field: 'productType', headerName: 'Product Type'},
      { field: 'productStatus', headerName: 'Status', width: 130 },
      { field: 'carrier', headerName: 'Carrier', width: 130},
      { field: 'carrierService', headerName: 'Provider Service' }, 
      { field: 'country', headerName: 'Service Country' },
      { field: 'currency', headerName: 'Top-up Currency', width: 230 },
      
      { field: 'commission_Value_type', headerName: 'Commission value', width: 230,cellRenderer: function (data) {
          if (data.value == '$') {
                //return this.currencyPipe.transform(parseFloat(data.data.purchaseDiscount));
                return this.currencyPipe.transform(data.data.commission_Value);
            }
            if (data.value == '%') {
              return data.data.commission_Value + '%'; //data.purchaseDiscount + '%';
            }
          } 
       },

      { field: 'faceValueMaxAmt', headerName: 'Face value max', cellRenderer: (data) => {
        return this.currencyPipe.transform(data.value)}  },
      { field: 'faceValueMinAmt', headerName: 'Face value min', cellRenderer: (data) => {
        return this.currencyPipe.transform(data.value)}  },
      { field: 'planType', headerName: 'Plan Type', },
      { field: 'providerId', headerName: 'Provider Id', },
      { field: 'providerName', headerName: 'Provider Name', },
      { field: 'purchase_price_type', headerName: 'Purchase Discount', width: 230,cellRenderer: function (data) {
          
          if (data.value == '$') {
                //return this.currencyPipe.transform(parseFloat(data.data.purchaseDiscount));
                return this.currencyPipe.transform(data.data.purchase_price);
            }
            if (data.value == '%') {
              return data.data.purchase_price + '%'; //data.purchaseDiscount + '%';
            }
          } 
       },
      { field: 'responseType', headerName: 'Response Type', },
    ]
  }


  onSelectionChanged(e) {
    this.router.navigate
   
    this.selectedRows = this.gridApi.getSelectedRows();
    if (this.selectedRows && this.selectedRows != []) {
      this.showEditRetailer = true;
    }

  }


  onPricelistSelect(e) {
    localStorage.setItem('pricelistSelected', this.PricelistSelected)
    this.providersService.getAllproductsforPricelist(this.PricelistSelected).subscribe(
      res => {
        this.rowData = res.data;
        this.isPricelistSelected = true;
      }
    );
  }



  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  exportData() {
    let header = this.columnDefs.map(columnDef => {
      let headerName = columnDef.headerName;
      return headerName;
      });
      let params: any = {
      fileName: 'pricelist-products.csv',
      //columnSeparator: ';',
      skipHeader: true,
      columnKeys: this.columnDefs.map(c => c.field || c.colId).filter(c => !!c)
      };
      params.customHeader = header.join(params.columnSeparator);
      params.processCellCallback = (cellParams) => {
      // 
      if(cellParams && cellParams.column.colId === '') {
        return ''; //apply your timestamp formatter 
      }else if(cellParams && cellParams.column.colId === 'commission_Value_type') {
       
        if (cellParams.node.data.commission_Value_type == '$') {
            return this.currencyPipe.transform(cellParams.node.data.commission_Value);
        }
        if (cellParams.node.data.commission_Value_type == '%') {
          return cellParams.node.data.commission_Value + '%'; 
        }
      }else if(cellParams && cellParams.column.colId === 'purchase_price_type') {
        if (cellParams.node.data.purchase_price_type == '$') {
          return this.currencyPipe.transform(cellParams.node.data.purchase_price);
        }
        if (cellParams.node.data.purchase_price_type == '%') {
          return cellParams.node.data.purchase_price + '%'; 
        }
      }else if(cellParams && cellParams.column.colId === 'accountCreatedDate') {
        return moment(cellParams.value).format('MM/DD/YYYY'); //apply your timestamp formatter 
      }
      
        else return cellParams.value // no formatting
      }
      this.gridApi.exportDataAsCsv(params);
  }

  editPricelist() {
    let _productId = this.selectedRows[0].productId;
    //let _productId = 35;
    this.router.navigate([`features/providers/consumer/update-product/${_productId}`])
    //this.router.navigate(['features/providers/pricelists/update-product/35'])
  }
  quickSearch() {
    this.gridApi.setQuickFilter(this.searchValue);
  }

  ngOnDestroy() {
    super.ngOnDestroy()
  }

}




